var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.479,
    height: 8.425,
    viewBox: "0 0 9.479 8.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#303030;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M166.791,424.4h1.9a.445.445,0,0,0-.474-.468h-.948a.445.445,0,0,0-.474.468M163,425.574a1.466,1.466,0,0,1,1.422-1.17h1.422a1.388,1.388,0,0,1,1.422-1.4h.948a1.388,1.388,0,0,1,1.422,1.4h1.422a1.192,1.192,0,1,1,0,2.34h-6.635a1.466,1.466,0,0,1-1.422-1.17m9.479,1.638v2.808a1.388,1.388,0,0,1-1.422,1.4h-6.635a1.388,1.388,0,0,1-1.422-1.4v-2.808a2.255,2.255,0,0,0,1.422.468h6.635a2.255,2.255,0,0,0,1.422-.468",
    transform: "translate(-163 -423)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfession);
export default __webpack_public_path__ + "static/media/profession.a3598b14.svg";
export { ForwardRef as ReactComponent };